export const getQueryParams = () => {
  // eslint-disable-line import/prefer-default-export
  const params = window.location.search
  return params ? params.replace(/^\?/, '') : ''
}
